import { setDateFormat } from '../../../lib/moment';
import { getKeyByValue } from '../../../lib/common';
import { EventsFindResponseBodyEventsDto } from '../../../types/api/events';
import { EventOption, ProductOption, TagOption } from './type';
import { GetEventListRequestType } from '../../../types/query/event/list';
import { DATE_FORMAT } from '../../../constants/service/common/utilConstants';
import { EVENT_STATUS } from '../../../constants/service/app/eventConstants';
import { PRODUCT_STATUS } from '../../../constants/service/app/productConstants';
import { STORE_STATUS } from '../../../constants/service/app/brandConstants';
import { CATEGORY_STATUS_TYPE } from '../../../constants/service/app/categoryConstants';

export const convertEventListRequest = (data: EventOption): GetEventListRequestType => ({
  page: data.pagination.pageNum + 1,
  pageSize: data.pagination.pageSize,
  status: getKeyByValue(EVENT_STATUS, data.filterOption.status) as keyof typeof EVENT_STATUS,
  mainTitle: data.filterOption.mainTitle,
});

export const convertEventListResponse = (eventList: EventsFindResponseBodyEventsDto[]) => {
  return eventList.map((event) => ({
    id: event.id,
    mainTitle: event.mainTitle,
    contents: event.contents,
    status: EVENT_STATUS[event.status],
    eventPeriod: `${setDateFormat(event.startDate, DATE_FORMAT.FULL_DASH_FORMAT)} - ${setDateFormat(
      event.endDate,
      DATE_FORMAT.FULL_DASH_FORMAT,
    )}`,
    url: event.eventAttachments[0]?.url,
    isTagExists: event.tags.length > 0,
  }));
};

/**
 * 기획전 아이템 리스트 노출 조건 - 판매 중 상품, 브랜드 활성, 카테고리 활성
 * @param options
 */
export const convertProductOptionRequest = (options: ProductOption) => ({
  id: options.filterOption.productId,
  name: options.filterOption.productName,
  storeId: options.filterOption.storeId,
  storeName: options.filterOption.brandName,
  page: options.pagination.pageNum + 1,
  pageSize: options.pagination.pageSize,
  sortBy: 'id',
  orderBy: 'DESC',
  status: PRODUCT_STATUS.NOW_ON_SALE,
  storeStatus: STORE_STATUS.ACTIVATE,
  categoryStatus: CATEGORY_STATUS_TYPE.ACTIVE,
});

/**
 * 태그 리스트 노출 조건 - 태그 활성
 * @param options
 */
export const convertTagOptionRequest = (options: TagOption) => {
  let sort = '';
  if (options.sortOption?.createDate === 'ascend') {
    sort = 'createDate';
  } else if (options.sortOption?.createDate === 'descend') {
    sort = '-createDate';
  }

  return {
    id: options.filterOption.tagId,
    name: options.filterOption.tagName,
    page: options.pagination.pageNum + 1,
    pageSize: options.pagination.pageSize,
    sort: sort,
    status: 'active',
  };
};
